var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReset = function SvgReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.8 3.1a.54.54 0 0 1-.535.47h-.073l-1.68-.22c2.946 3.788 2.272 9.255-1.505 12.21a8.655 8.655 0 0 1-12.173-1.51C-1.11 10.261-.438 4.795 3.34 1.84A8.66 8.66 0 0 1 8.682 0a.543.543 0 0 1 0 1.088c-4.191-.002-7.59 3.405-7.592 7.609s3.395 7.613 7.586 7.615 7.59-3.405 7.592-7.61a7.63 7.63 0 0 0-1.696-4.798l-.09 2.103a.543.543 0 0 1-.538.518h-.026a.536.536 0 0 1-.516-.566l.144-3.374a.1.1 0 0 1 0-.026.3.3 0 0 1 0-.054v-.076a.1.1 0 0 1 0-.022.5.5 0 0 1 .083-.134.5.5 0 0 1 .188-.142l.072-.025h.213l3.177.424c.3.012.532.265.52.565v.004"
  })));
};
export default SvgReset;